/** @format */

import React, { Component } from 'react';
import { Segment, Header, Form, Divider, Grid, Icon } from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import { getUnixDateFromTimestamp } from '../../../../helpers/getUnixDateFromTimestamp';
import ArchiveModal from './ArchiveModal';

@inject('RequestsStore')
@observer
class ArchiveRequests extends Component {
  constructor(props, context) {
    super(props, context);
    let date = new Date();
    date.setMonth(date.getMonth() - 1);
    const timestamp = (date.getTime() / 1000) * -1;
    this.state = {
      modal: false,
      date: getUnixDateFromTimestamp(timestamp),
      loading: false,
    };
  }

  onChange(e) {
    this.setState({
      date: e.target.value,
    });
  }

  onSubmit(e) {
    const { RequestsStore } = this.props;
    this.setState({ loading: true }, () => {
      const promise = RequestsStore.archiveRequests(new Date(this.state.date));
      promise.then(response => {
        this.toggleModal();
        this.setState({ loading: false });
      });
    });
  }

  toggleModal(e) {
    this.setState({
      modal: !this.state.modal,
    });
  }

  render() {
    const date = new Date(this.state.date);
    const timestamp = (date.getTime() / 1000) * -1;
    const value = getUnixDateFromTimestamp(timestamp);
    return (
      <Segment textAlign="center">
        <Header as="h3" children="Archivia Richieste" />
        <Divider />
        <Form>
          <Grid columns="2">
            <Grid.Row>
              <Grid.Column textAlign="center">
                <Form.Field>
                  <label>Data</label>
                  <input
                    type="date"
                    name="date"
                    value={value}
                    onChange={this.onChange.bind(this)}
                  />
                </Form.Field>
              </Grid.Column>
              <Grid.Column textAlign="center">
                <Form.Button
                  onClick={this.toggleModal.bind(this)}
                  label={`Archivia le richieste precenti il ${value}`}
                >
                  {this.state.loading ? (
                    <Icon name="spinner" loading />
                  ) : (
                    'Archivia'
                  )}
                </Form.Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
        <ArchiveModal
          open={this.state.modal}
          toggleModal={this.toggleModal.bind(this)}
          onSubmit={this.onSubmit.bind(this)}
          loading={this.state.loading}
        />
      </Segment>
    );
  }
}

export default ArchiveRequests;
